var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZircuitBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 100,
    viewBox: "0 0 420 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38060_288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 420,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 100,
    rx: 8,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38060_288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343 66.8689C343.151 54.1704 347.756 43.3505 357.014 34.6506C364.039 28.0493 372.464 24.2684 382.077 23.2723C394.312 22.0041 405.34 25.158 414.878 32.895C423.516 39.9032 428.731 49.0432 430.425 60.0737C432.396 72.9118 429.285 84.4557 421.318 94.7006C420.643 95.5682 419.924 95.6194 419.16 94.8544C408.729 84.4344 398.287 74.0238 387.879 63.5825C387.228 62.9295 386.878 62.9744 386.275 63.5825C380.312 69.597 374.336 75.5972 368.345 81.5857C363.828 86.1001 359.274 90.5766 354.773 95.1076C353.993 95.8931 353.47 95.7488 352.864 94.9869C347.652 88.459 344.443 81.0722 343.298 72.7864C343.026 70.8226 343.035 68.8564 343 66.8689ZM386.928 30.8862C384.978 30.8578 383.033 30.8791 381.141 31.2671C366.4 34.3004 356.598 42.927 352.213 57.3622C349.623 65.8941 350.675 74.2841 354.208 82.3996C354.773 83.6962 354.967 83.7222 355.982 82.7119C357.854 80.8475 359.709 78.9665 361.585 77.1091C366.346 72.4007 371.135 67.7183 375.876 62.991C379.222 59.6572 382.506 56.262 385.821 52.8975C386.873 51.828 387.105 51.8233 388.014 52.7389C390.789 55.5332 393.565 58.3275 396.352 61.11C403.575 68.3217 410.806 75.5286 418.034 82.7379C419.066 83.7672 419.12 83.7932 419.674 82.4824C425.542 68.5961 424.269 55.5474 414.537 43.8355C407.434 35.287 398.131 30.917 386.925 30.8862H386.928Z",
    fill: "#007C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.12 111.062C377.632 110.977 368.986 108.341 361.245 102.868C360.473 102.324 359.756 101.704 359.004 101.129C358.375 100.649 358.294 100.216 358.907 99.6007C362.965 95.5216 366.98 91.4023 371.035 87.3233C375.841 82.4871 380.672 77.6746 385.494 72.855C386.942 71.407 386.918 71.4354 388.324 72.8408C391.918 76.4324 395.55 79.9815 399.141 83.5755C403.403 87.8391 407.628 92.1358 411.882 96.4065C412.938 97.4665 414.031 98.4934 415.129 99.5108C415.76 100.098 415.798 100.531 415.058 101.113C408.729 106.079 401.659 109.37 393.671 110.544C391.494 110.863 389.282 110.96 388.123 111.064L388.12 111.062Z",
    fill: "#007C20"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZircuitBg);
export default __webpack_public_path__ + "static/media/zircuit_bg.2c381299ebb51d13b6f45ff9b77b47a5.svg";
export { ForwardRef as ReactComponent };